import axios from "axios";
import { toast } from "react-toastify";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

const API = axios.create({
  baseURL: "https://api.shabakemadar.com/public/api",
  // baseURL: "https://mother-channel.25.vistadev.ir/public/api",
  timeout: 0,
  headers: {
    common: {
      Accept: "application/json",
      Authorization: `Bearer ${cookies.get("fHX6UVhQgR")}`,
    },
    post: {
      "Content-Type": "application/json",
    },
    "X-Localization": localStorage.getItem("isEnglish") ? "en" : "fa",
  },
});

API.navigate = null;

API.interceptors.response.use(
  (res) => {
    if (res.data.success) {
      return res.data.data;
  
    } else {
      toast.error(res.data.message);
      return Promise.reject();
    }
    
  },

  (err) => {
    if (err.code !== "ERR_CANCELED" && !err.response?.status)
      toast.error(
        "خطا در ارتباط با سرور! لطفا اتصال اینترنت خود را برررسی کنید."
      );
    else {
      switch (err.response.status) {
        // Unauthorized
          
        case 401:
          cookies.remove("fHX6UVhQgR", { path: "/" });
          localStorage.removeItem("token");
          localStorage.removeItem("userData");
          API.defaults.headers.common.Authorization = undefined;
          toast.error("توکن شما منقضی شده است! لطفا دوباره وارد شوید.");
          API.navigate("/", { replace: true });
          break;

        // Unauthenticated
        case 403:
          toast.error("شما مجوز دسترسی به این صفجه را ندارید.");
          API.navigate("/", { replace: true });
          break;

        // Not found
        case 404:
          API.navigate("/not-found", { replace: true });
          break;

        // Unprocessable content
        case 422:
          let errors = [];
          for (let error in err.response.data.errors) {
            err.response.data.errors[error].forEach((item) =>
                 errors.push(item)
            );
          }
          toast.error(`
            ${"خطا! مقادیر ورودی زیر اشتباه می‌باشند:"}
            ${errors.map((item, index) => index + 1 + " - " + item + "\n")}
          `);
  
          /*     toast.error(
                 <pre>
                   {"خطا! مقادیر ورودی زیر ناقص، یا اشتباه می‌باشند:" + "\n"}
                   {errors.map((item, index) => index + 1 + " - " + item + "\n")}
                 </pre>
               );*/
          break;

        // Too many requests
        case 429:
          toast.error(
            "تعداد درخواست‌های شما از حد مجاز عبور کرده است! لطفا بعدا تلاش کنید."
          );
          break;

        // Server-side error
        case 500:
          toast.error("خطایی در سمت سرور پیش‌ آمده! لطفا بعدا تلاش کنید.");
          break;

        default:
          break;
      }
    }

    return Promise.reject(err);
  }
);

export default API;
